<div style="height: 100%; width: 100%;">
  <div style="height: 100%; width: 100%; position: relative">
    <mat-spinner *ngIf="!loadComplete" diameter="100" color="#03738c" class="spinner"></mat-spinner>
    <pdf-viewer *ngIf="pdfSource"
                [render-text]="true"
                zoom-scale="page-width"
                [original-size]="false"
                (after-load-complete)="loadComplete = true"
                [show-borders]="true"
                [src]="pdfSource"
                [stick-to-page]="true"
               ></pdf-viewer>
  </div>
</div>
